export default "__VITE_ASSET__akZ9naFe__"